import React from 'react';
import LeagueManagerSideBarleft from './LeagueManagerSideBarLeft';

function LeagueManagerLayout({ children }) {
    return (
        <div className="container">
            <div className="row g-4">
                {/* Left sidebar (always visible) */}
                <div className="col-lg-3">
                    <LeagueManagerSideBarleft />
                </div>

                {/* Right-side content changes depending on route */}
                <div className="col-lg-9">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default LeagueManagerLayout;